<h1 mat-dialog-title>{{title}}</h1>
<mat-dialog-content>
  @if (isInvite) {
    <p class="intro">They'll get an email inviting them to join. If they don't have a LINQ account yet, the email lets them set one up.</p>
  }
  @if (message) {
    <p class="billing">{{message}}</p>
  }
  <form [formGroup]="userForm" (ngSubmit)="save()">
    <mat-form-field>
      <mat-label>Name</mat-label>
      <input matInput formControlName="name" placeholder="First and last name" id="user-name" type="text" [errorStateMatcher]="matcher" [maxlength]="USER_NAME_MAX" required>
      @if (userForm.controls['name'].invalid) {
        <mat-error>{{getNameError()}}</mat-error>
      }
    </mat-form-field>
    <mat-form-field>
      <mat-label>Email</mat-label>
      <input matInput formControlName="email" placeholder="name@example.com" id="user-email" type="email" [errorStateMatcher]="matcher" [maxlength]="EMAIL_MAX" [required]="isInvite">
      @if (!isInvite) {
        <mat-hint>{{isSelf ? 'Your email is' : 'The email is'}} used to sign in, so it can't be changed here</mat-hint>
      }@else if (isPendingInvite()) {
        <mat-hint>{{getMemberName()}} has been invited but hasn't joined yet. This sends the invitation again.</mat-hint>
      }
      @if (userForm.controls['email'].hasError('required')) {
        <mat-error>Email is <strong>required</strong></mat-error>
      }@else if (userForm.controls['email'].hasError('member')) {
        <mat-error>{{getMemberName()}} is already a member of this organisation</mat-error>
      }@else if (userForm.controls['email'].invalid) {
        <mat-error>Enter a valid email address</mat-error>
      }
    </mat-form-field>

    @if (roleControl) {
      <label class="label" id="user-role-label">Organisation role</label>
      <mat-radio-group class="roles" [formControl]="roleControl" aria-labelledby="user-role-label" id="user-org-role">
        @for (r of roles; track r.role) {
          <mat-radio-button [value]="r.role">
            <span class="role-name">{{r.name}}</span>
            <span class="role-description">{{r.description}}</span>
          </mat-radio-button>
        }
      </mat-radio-group>
    }

    @if (!isInvite) {
      <h3>{{isSelf ? 'Your modelling preferences' : 'Modelling preferences'}}</h3>
      <mat-form-field>
        <mat-label>Model direction</mat-label>
        <mat-select formControlName="graphDirection" required>
          <mat-option [value]="LAYOUT_DIRECTION.DOWN">Top to bottom</mat-option>
          <mat-option [value]="LAYOUT_DIRECTION.UP">Bottom to top</mat-option>
          <mat-option [value]="LAYOUT_DIRECTION.LEFT_RIGHT">Left to right</mat-option>
          <mat-option [value]="LAYOUT_DIRECTION.RIGHT_LEFT">Right to left</mat-option>
        </mat-select>
        <mat-hint>Which way models flow</mat-hint>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Moving nodes</mat-label>
        <mat-select formControlName="nodeMoveOption" required>
          <mat-option [value]="NODE_MOVE_OPTION.SELECTED">Drag a selected node to move it; drag an unselected node to draw an edge</mat-option>
          <mat-option [value]="NODE_MOVE_OPTION.SHIFT_MOVE_NODE">Hold shift to move a node</mat-option>
          <mat-option [value]="NODE_MOVE_OPTION.SHIFT_DRAW_EDGE">Hold shift to draw an edge</mat-option>
        </mat-select>
        <mat-hint>How dragging a node behaves</mat-hint>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Edge shape</mat-label>
        <mat-select formControlName="edgeRoutingStyle" required>
          <mat-option [value]="EDGE_STYLE_ROUTING.POLYLINE">Single angled bends</mat-option>
          <mat-option [value]="EDGE_STYLE_ROUTING.OCTILINEAR">Multiple bend angles</mat-option>
          <mat-option [value]="EDGE_STYLE_ROUTING.ORTHOGONAL">Right angled bends</mat-option>
          <mat-option [value]="EDGE_STYLE_ROUTING.CURVED">Curved bends</mat-option>
        </mat-select>
        <mat-hint>How edges between nodes are drawn</mat-hint>
      </mat-form-field>
    }
    <button type="submit" hidden></button>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="dialogRef.close()">Cancel</button>
  <button mat-flat-button color="accent" cdkFocusInitial (click)="save()">{{isInvite ? 'Send invitation' : 'Save'}}</button>
</mat-dialog-actions>
